import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-4a20d4a6")
const _hoisted_1 = { class: "grid grid-cols-1 gap-y-12" }
const _hoisted_2 = { class: "info-wrapper gap-y-8" }
const _hoisted_3 = { class: "grid md:col-start-1 md:col-end-3 gap-y-8" }
const _hoisted_4 = { class: "grid grid-cols-1 gap-y-4" }
const _hoisted_5 = { class: "flex justify-between items-end" }
const _hoisted_6 = { class: "text-xl font-semibold text-purple-500" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "$ 15.67", -1)
const _hoisted_8 = { class: "text-gray-500 text-xs" }
const _hoisted_9 = { class: "grid grid-cols-1 gap-y-4" }
const _hoisted_10 = { class: "flex justify-between items-end" }
const _hoisted_11 = { class: "text-xl font-semibold text-purple-500" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "$ 15.67", -1)
const _hoisted_13 = { class: "text-gray-500 text-xs" }
const _hoisted_14 = { class: "grid gap-y-8 py-8 md:py-0 md:grid-cols-2 h-full items-center justify-items-center" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "text-4xl font-semibold text-purple-500" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", null, "$ 151.67", -1)
const _hoisted_18 = { class: "legend-grid" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "w-8 h-8 gradient-purple-diagonal rounded-full" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "w-8 h-8 bg-purple-100 rounded-full" }, null, -1)
const _hoisted_21 = { class: "grid gap-y-4" }
const _hoisted_22 = { class: "px-4 md:px-0" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_BalCard = _resolveComponent("BalCard")!
  const _component_ve_progress = _resolveComponent("ve-progress")!
  const _component_PoolsTable = _resolveComponent("PoolsTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_BalCard, { growContent: "" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t('availableToClaim')), 1),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.formatToken(_ctx.claimableRewards)) + " HALT", 1),
                _hoisted_7
              ]),
              _createVNode(_component_BalBtn, {
                color: "purple",
                outline: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('claim')), 1)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('availableToClaimWarning')), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_BalCard, { growContent: "" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t('lockedRewards')), 1),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.formatToken(_ctx.lockedRewards)) + " HALT", 1),
                _hoisted_12
              ]),
              _createVNode(_component_BalBtn, {
                color: "purple",
                outline: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('claim')), 1)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('lockedRewardsWarning')), 1)
            ])
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_BalCard, {
        growContent: "",
        class: "md:col-start-4 md:col-end-9"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_ve_progress, {
              line: "butt",
              color: _ctx.completedSteps ? _ctx.gradient : 'transparent',
              thickness: 32,
              emptyThickness: 30,
              progress: _ctx.completedSteps,
              size: 350
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("h3", null, _toDisplayString(_ctx.$t('totalRewards')), 1),
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.formatToken(_ctx.totalRewards)) + " HALT ", 1),
                  _hoisted_17
                ])
              ]),
              _: 1
            }, 8, ["color", "progress"]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('availableToClaim')), 1),
              _hoisted_20,
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('lockedRewards')), 1)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("h3", _hoisted_22, _toDisplayString(_ctx.$t('yourRewardPools')), 1),
      _createVNode(_component_PoolsTable, {
        isLoading: _ctx.isLoadingUserRewardPools,
        data: _ctx.userRewardPools,
        noPoolsLabel: _ctx.$t('noInvestments'),
        showPoolShares: "",
        showEarnedRewards: "",
        selectedTokens: []
      }, null, 8, ["isLoading", "data", "noPoolsLabel"])
    ])
  ]))
}